var _defs, _ellipse, _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _path6, _path7, _path8, _path9, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path10, _path11, _path12, _rect10, _circle, _polygon, _path13, _path14, _rect11, _path15, _path16, _rect12, _circle2, _circle3, _path17, _path18, _path19, _circle4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect13, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _rect14, _path44, _circle5, _circle6, _circle7, _circle8, _circle9, _path45, _path46, _path47, _path48, _path49, _rect15, _path50, _path51, _rect16, _circle10, _ellipse2, _ellipse3, _circle11, _ellipse4, _ellipse5, _path52, _path53, _rect17, _path54, _path55, _path56, _path57;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc1eb;}.cls-2{fill:#fff;}.cls-3{fill:#ffbb45;}.cls-4{fill:#6dc8c2;}.cls-5{fill:#fb6d6d;}.cls-6{fill:#c7b8f8;}.cls-7{fill:#f3ead6;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 480.48,
    cy: 833.36,
    rx: 283.04,
    ry: 43.67
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 346.92,
    y: 720.28,
    width: 11.55,
    height: 92.2,
    rx: 4.02,
    transform: "translate(-490.95 764.22) rotate(-65.14)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.21,719.14l38,10,51.33,23.79-8.76,18.92a7.2,7.2,0,0,1-9.55,3.5l-67.57-31.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387.24,778a9.12,9.12,0,0,1-3.85-.85L314.83,745.4l-4-29,41.24,10.89L405.2,752l-9.61,20.74A9.2,9.2,0,0,1,387.24,778ZM318.5,742.69l66.57,30.85A5.19,5.19,0,0,0,392,771l7.93-17.11L350.53,731l-34.93-9.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M322,758.52l-43.22-20a6.61,6.61,0,0,1-3.22-8.77h0a27.12,27.12,0,0,1,36-13.2h0a27.11,27.11,0,0,1,13.2,36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M662.17,336.89,640,338.24a38.27,38.27,0,0,1-40.52-35.87l-1.25-20.61a34,34,0,0,1,31.9-36l17.28-1.05a47.26,47.26,0,0,1,50,44.3l.46,7.6A38.06,38.06,0,0,1,662.17,336.89Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.63,836a2,2,0,0,1-2-1.66L228,526.33l-81.8,307.85a2,2,0,0,1-3.87-1L228.8,507.69l56.8,326A2,2,0,0,1,284,836,2,2,0,0,1,283.63,836Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 181.38,
    y: 489.17,
    width: 422.55,
    height: 27.84,
    rx: 8.79
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 476.5,
    y: 199.14,
    width: 109.62,
    height: 37.78,
    rx: 18.89
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M567.24,238.91H495.39a20.89,20.89,0,1,1,0-41.77h71.85a20.89,20.89,0,1,1,0,41.77Zm-71.85-37.77a16.89,16.89,0,1,0,0,33.77h71.85a16.89,16.89,0,1,0,0-33.77Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M507.69,227.13l-5.12-2.7a.53.53,0,0,0-.49,0l-5.12,2.7a.53.53,0,0,1-.76-.56l1-5.7a.55.55,0,0,0-.16-.47l-4.14-4a.52.52,0,0,1,.29-.89l5.73-.84a.5.5,0,0,0,.39-.28l2.57-5.19a.52.52,0,0,1,.94,0l2.56,5.19a.52.52,0,0,0,.4.28l5.72.84a.52.52,0,0,1,.29.89l-4.14,4a.54.54,0,0,0-.15.47l1,5.7A.53.53,0,0,1,507.69,227.13Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M536.68,227.13l-5.12-2.7a.53.53,0,0,0-.49,0l-5.12,2.7a.53.53,0,0,1-.77-.56l1-5.7a.52.52,0,0,0-.15-.47l-4.14-4a.52.52,0,0,1,.29-.89l5.73-.84a.5.5,0,0,0,.39-.28l2.56-5.19a.53.53,0,0,1,.95,0l2.56,5.19a.5.5,0,0,0,.39.28l5.73.84a.52.52,0,0,1,.29.89l-4.14,4a.52.52,0,0,0-.15.47l1,5.7A.53.53,0,0,1,536.68,227.13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M565.67,227.13l-5.12-2.7a.53.53,0,0,0-.49,0l-5.12,2.7a.53.53,0,0,1-.77-.56l1-5.7a.54.54,0,0,0-.15-.47l-4.14-4a.52.52,0,0,1,.29-.89l5.72-.84a.53.53,0,0,0,.4-.28l2.56-5.19a.52.52,0,0,1,.94,0l2.56,5.19a.53.53,0,0,0,.4.28l5.73.84a.52.52,0,0,1,.29.89l-4.15,4a.54.54,0,0,0-.15.47l1,5.7A.53.53,0,0,1,565.67,227.13Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 243.28,
    y: 256.62,
    width: 292.94,
    height: 195.73,
    rx: 19.22
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 262.67,
    y: 273.51,
    width: 254.16,
    height: 165.89,
    rx: 14.65
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 333.41,
    y: 301.23,
    width: 84.34,
    height: 115.65,
    rx: 10.26
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 283.75,
    y: 298.09,
    width: 31.11,
    height: 31.11,
    rx: 4.29
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 283.75,
    y: 343.83,
    width: 31.11,
    height: 31.11,
    rx: 5.12
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 283.75,
    y: 389.56,
    width: 31.11,
    height: 31.11,
    rx: 5.18
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M501.07,305.49H434.31a2,2,0,1,1,0-4h66.76a2,2,0,0,1,0,4Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M501.07,324H434.31a2,2,0,0,1,0-4h66.76a2,2,0,0,1,0,4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M480.34,342.42h-46a2,2,0,0,1,0-4h46a2,2,0,0,1,0,4Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 432.38,
    y: 356.34,
    width: 45.56,
    height: 17.74,
    rx: 8.87
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 496.46,
    cy: 365.22,
    r: 8.33
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "392.39 489.17 322.71 489.17 351.24 452.35 423.78 452.35 392.39 489.17"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M693.7,618.16a2.05,2.05,0,0,1-.49-.06,2,2,0,0,1-1.45-2.43l26.32-104a2,2,0,1,1,3.88,1l-26.32,104A2,2,0,0,1,693.7,618.16Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M549.15,831.63a1.23,1.23,0,0,1-.27,0,2,2,0,0,1-1.72-2.25l26.93-198.81a2,2,0,1,1,4,.53L551.13,829.9A2,2,0,0,1,549.15,831.63Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 674.45,
    y: 432.23,
    width: 119.61,
    height: 43.64,
    rx: 13.99,
    transform: "translate(128.88 1069.52) rotate(-77.21)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M695.11,831.63a2,2,0,0,1-2-1.72L665,631.09a2,2,0,1,1,4-.56l28.1,198.82a2,2,0,0,1-1.7,2.26A1.32,1.32,0,0,1,695.11,831.63Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M685.8,765.73H558.07a2,2,0,0,1,0-4H685.8a2,2,0,0,1,0,4Z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 549.15,
    y: 583.89,
    width: 148.7,
    height: 46.92,
    rx: 13.82
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 701.53,
    cy: 250.55,
    r: 29.65
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.97,
    cy: 223.78,
    r: 39.8
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M682.16,306.67a13,13,0,0,0-13-13,13.68,13.68,0,0,0-1.82.14l-2.49-34.12-48.53,5.21a20.3,20.3,0,0,0-18.15,20.19v5.49a33.51,33.51,0,0,1-5.1,18l-.09.13,0,.05a4.69,4.69,0,0,0,1.84,6.8l3.38,1.66v12.86a17.7,17.7,0,0,0,20.44,17.49l12.46-1.94L633.6,367l39.67-4.68-2.69-22.81h.12l-1.45-19.85A13,13,0,0,0,682.16,306.67Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M631.85,369.22,629.34,348l-10.4,1.62a19.7,19.7,0,0,1-22.74-19.47V318.52l-2.27-1.11a6.64,6.64,0,0,1-3.49-4.19,6.85,6.85,0,0,1,.85-5.5l.11-.17a31.4,31.4,0,0,0,4.8-16.95v-5.49a22.26,22.26,0,0,1,19.92-22.18l50.59-5.43,2.5,34.19a15,15,0,0,1,2.18,29.79l1.43,19.71h0l2.7,22.88Zm1-25.84,2.52,21.4,35.7-4.21-2.68-22.73.2,0-1.47-20.15h2.14a11,11,0,0,0-.06-22,11.38,11.38,0,0,0-1.54.12l-2.12.3L663,261.92l-46.48,5a18.27,18.27,0,0,0-16.35,18.2v5.49a35.39,35.39,0,0,1-5.43,19.1l-.1.16a2.84,2.84,0,0,0-.37,2.29,2.61,2.61,0,0,0,1.39,1.67l4.51,2.2v14.11a15.71,15.71,0,0,0,18.12,15.52Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M611,332.17a8.92,8.92,0,0,1-1.52-.13,10.1,10.1,0,0,1-5.16-2.56,2,2,0,0,1,2.7-3,6.31,6.31,0,0,0,3.11,1.57c3.7.61,6.61-3,6.64-3a2,2,0,0,1,3.15,2.46C619.71,327.74,616.18,332.17,611,332.17Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 619.19,
    cy: 301.91,
    r: 3.15
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M667.84,313.42a5.38,5.38,0,1,1,5.38-5.38A5.38,5.38,0,0,1,667.84,313.42Zm0-6.76a1.38,1.38,0,1,0,1.38,1.38A1.38,1.38,0,0,0,667.84,306.66Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.64,361.6l60.86-2.76a34.56,34.56,0,0,1,24.86,8.65c8.77,8,15.63,22.69,6.08,49.39L714,441.93l-76-9.2-13.13,25.54-47.7,5.45c-1.18.13-4.83-6.15-5.34-6.94a47,47,0,0,1-7.24-19.19c-2.5-19.52,12-35.2,23.23-49.47C599.74,372.9,615.58,362.51,635.64,361.6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M664.58,310.92a2,2,0,0,1-2-1.61,7.85,7.85,0,0,1,2.48-7.42,8.18,8.18,0,0,1,7.26-1.65,2,2,0,0,1-1.07,3.86,4.12,4.12,0,0,0-3.55.79,3.85,3.85,0,0,0-1.2,3.63,2,2,0,0,1-1.56,2.36A2.85,2.85,0,0,1,664.58,310.92Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M616.34,264.92s-.65,40.29,51.41,28.85l-2.88-34.06Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M619.92,319.41c-8.26,0-15-7.79-15-17.38s6.73-17.38,15-17.38,15,7.8,15,17.38S628.19,319.41,619.92,319.41Zm0-30.76c-6.06,0-11,6-11,13.38s4.93,13.38,11,13.38,11-6,11-13.38S626,288.65,619.92,288.65Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M688.44,529.89H612V479.15h70.63a142.48,142.48,0,0,1,5.85,50.74Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M495.73,489.17H456.35a14.14,14.14,0,0,1-13.61-18.06h0a13.62,13.62,0,0,1,13.09-9.81h40.41a13.62,13.62,0,0,1,12.9,9.23h0A14.12,14.12,0,0,1,495.73,489.17Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M636.82,432.73l-12.94,25.54-74.53,7.42a14.43,14.43,0,0,1-8.08-1.55L509,447.38s-11.27-6.31-27.56.49L454,460.32a6,6,0,0,0-3.6,6v.06a3.61,3.61,0,0,0,4.55,3L484,461.23l-13.61,12.31a13,13,0,0,0-4,6.79c-.92,4.27.19,10.06,11.25,12.7,0,0,5.09,8.55,13.75,4,.05,0,1.28,1.09,1.38,1.16a27.34,27.34,0,0,0,4.32,2.73,37.45,37.45,0,0,0,15.3,3.89c3.3.16,6.4-1.28,6.83-4.86l2.78.29q13,1.33,25.89,3.82l65.73,12.71c18,2.55,30.88-1.3,37.45-3.9,19.2-7.59,31.64-21.09,41.62-38.24l19-32.71Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M625.37,519.63a85.77,85.77,0,0,1-12-.87l-.1,0L547.5,506c-8.48-1.64-17.13-2.91-25.71-3.8l-1.08-.11c-1.22,3.07-4.4,4.9-8.43,4.7a39.63,39.63,0,0,1-16.12-4.11,31,31,0,0,1-4.63-2.92l-.39-.34-.07-.06c-7,2.93-12.38-1.31-14.69-4.61-12.47-3.27-12.86-10.69-12-14.87a14.82,14.82,0,0,1,4.66-7.85l7.32-6.62-20.94,5.85a5.61,5.61,0,0,1-7.07-4.61,8,8,0,0,1,4.71-8.16l27.55-12.47c17.05-7.12,28.87-.69,29.37-.41l32.17,16.72a12.39,12.39,0,0,0,7,1.34l73.43-7.31,13.08-25.81L715,440.31l-20.57,35.34c-11.48,19.71-25,32.13-42.61,39.09A71.54,71.54,0,0,1,625.37,519.63Zm-11.43-4.83c13.1,1.85,25.35.58,36.39-3.78,16.94-6.7,29.47-18.23,40.62-37.38l17.52-30.1L638,434.89l-12.8,25.26-75.62,7.53a16.4,16.4,0,0,1-9.2-1.77l-32.23-16.75c-.48-.26-10.76-5.76-25.87.56l-27.46,12.42a4,4,0,0,0-2.45,3.92,1.64,1.64,0,0,0,2.05,1.38L491.66,457l-19.89,18a10.87,10.87,0,0,0-3.44,5.72c-1.09,5.05,2.19,8.53,9.76,10.33l.82.2.43.73c.43.7,4.38,6.79,11.11,3.25,1.26-.66,2.09.08,3.35,1.2l.23.21a26.53,26.53,0,0,0,4,2.49,35.67,35.67,0,0,0,14.48,3.66c1.31.06,4.39-.1,4.74-3.1l.23-2,4.75.49c8.69.89,17.46,2.18,26.06,3.85Zm-121.62-16h0Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 818.66,
    width: 92.2,
    height: 11.55,
    rx: 4.02
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.41,798.17l38.68-6.9h56.58v20.86a7.19,7.19,0,0,1-7.19,7.19H439Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M513.48,821.32H437.93L422.1,796.73l42-7.46h58.58v22.86A9.2,9.2,0,0,1,513.48,821.32Zm-73.37-4h73.37a5.2,5.2,0,0,0,5.19-5.19V793.27h-54.4l-35.56,6.34Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M377.43,751.82l-23.25-17a33.78,33.78,0,0,1-7.39-47.2l101.3-138.92a49.54,49.54,0,0,1,69.23-10.84h0a49.54,49.54,0,0,1,10.84,69.23L428.48,743.83A36.54,36.54,0,0,1,377.43,751.82Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M619.14,601h-177V566.22a50.46,50.46,0,0,1,50.46-50.45H688.44V531.7A69.3,69.3,0,0,1,619.14,601Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M504.74,796.16H476a33.79,33.79,0,0,1-33.79-33.78V596.73h99.1V759.62A36.53,36.53,0,0,1,504.74,796.16Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.31,752.52a2,2,0,0,1-1.63-3.15l52.86-75a2,2,0,0,1,3.27,2.31l-52.86,75A2,2,0,0,1,389.31,752.52Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M509.9,797.79a2,2,0,0,1-2-2V592.61a28.4,28.4,0,0,1,28.37-28.38h77.78a30.85,30.85,0,0,0,30.82-30.82V515.77a2,2,0,0,1,4,0v17.64a34.86,34.86,0,0,1-34.82,34.82H536.27a24.4,24.4,0,0,0-24.37,24.38V795.79A2,2,0,0,1,509.9,797.79Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M477.62,495a2,2,0,0,1-1.91-1.44c-4.64-15.89,12.39-25.71,12.57-25.81a2,2,0,1,1,2,3.48h0a29.55,29.55,0,0,0-6.94,5.94c-4,4.82-5.31,9.95-3.75,15.27a2,2,0,0,1-1.36,2.48A2.24,2.24,0,0,1,477.62,495Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M491.38,499a2,2,0,0,1-1.65-.88,12.59,12.59,0,0,1-2.12-10.34c2-8.42,12.17-14.15,12.61-14.39a2,2,0,1,1,1.94,3.49c-.16.1-9.08,5.16-10.66,11.83a8.67,8.67,0,0,0,1.53,7.16,2,2,0,0,1-1.65,3.13Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M519.21,502a2,2,0,0,1-2-1.76c-.39-3.2-6.9-7-10-8.31l-2.76-1.18,9.58-9.27a2,2,0,0,1,2.78,2.87l-5.37,5.2c3.51,1.88,9.17,5.6,9.73,10.21a2,2,0,0,1-1.74,2.22Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M449.91,830.22H402.28a6.61,6.61,0,0,1-6.61-6.61h0a27.13,27.13,0,0,1,27.12-27.12h0a27.12,27.12,0,0,1,27.12,27.12Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M632.92,301.17a2,2,0,0,1-.22-4l31.54-3.49a2,2,0,0,1,.44,4l-31.54,3.48Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M631.34,343.63l1.41,12,20.88-13.77a.76.76,0,0,0-.53-1.39Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M636.82,434.73a2,2,0,0,1-.8-.16,2,2,0,0,1-1-2.63l8.2-18.88a2,2,0,1,1,3.67,1.59l-8.21,18.88A2,2,0,0,1,636.82,434.73Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M442.78,723.11a2,2,0,0,1-2-2V558.39a2,2,0,0,1,4,0V721.11A2,2,0,0,1,442.78,723.11Z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 745.36,
    y: 298.73,
    width: 226.13,
    height: 155.32,
    rx: 22.12
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M949.37,456.05H767.48a24.15,24.15,0,0,1-24.12-24.12V320.85a24.15,24.15,0,0,1,24.12-24.12H949.37a24.15,24.15,0,0,1,24.12,24.12V431.93A24.15,24.15,0,0,1,949.37,456.05ZM767.48,300.73a20.14,20.14,0,0,0-20.12,20.12V431.93a20.14,20.14,0,0,0,20.12,20.12H949.37a20.15,20.15,0,0,0,20.12-20.12V320.85a20.14,20.14,0,0,0-20.12-20.12Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 868.66,
    cy: 348.77,
    r: 6.75
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.04,
    cy: 348.77,
    r: 6.75
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 915.43,
    cy: 348.77,
    r: 6.75
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 938.82,
    cy: 348.77,
    r: 6.75
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 803.42,
    cy: 368.63,
    r: 13.11
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M802.26,388.44a25.81,25.81,0,0,0-21.94,11.94,37.3,37.3,0,0,0,44.62,1.25A25.75,25.75,0,0,0,802.26,388.44Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M945.57,376h-85a2,2,0,1,1,0-4h85a2,2,0,0,1,0,4Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M945.57,391.7h-85a2,2,0,0,1,0-4h85a2,2,0,0,1,0,4Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M914,407.42H860.61a2,2,0,0,1,0-4H914a2,2,0,0,1,0,4Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M802.63,409.36a35.27,35.27,0,1,1,35.27-35.27A35.31,35.31,0,0,1,802.63,409.36Zm0-66.53a31.27,31.27,0,1,0,31.27,31.26A31.3,31.3,0,0,0,802.63,342.83Z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 763.59,
    y: 515.77,
    width: 96.3,
    height: 96.3,
    rx: 15.16
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M844.73,614.07h-66a17.18,17.18,0,0,1-17.17-17.16v-66a17.18,17.18,0,0,1,17.17-17.16h66a17.18,17.18,0,0,1,17.17,17.16v66A17.18,17.18,0,0,1,844.73,614.07Zm-66-96.3a13.18,13.18,0,0,0-13.17,13.16v66a13.18,13.18,0,0,0,13.17,13.16h66a13.18,13.18,0,0,0,13.17-13.16v-66a13.18,13.18,0,0,0-13.17-13.16Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M796.34,586.71V564.08a2.23,2.23,0,0,1,1.15-2c3.16-1.77,11.85-7.66,12.86-19.59.37-4.31,2.26-6.34,4.25-6.83,2.3-.56,4.67,1.84,5,2.16,5.41,5.64-.24,18.57-.76,19.73l7.15-.19a10.65,10.65,0,0,1,10.92,10.39l.25,10.24a10.64,10.64,0,0,1-10.64,10.9H798.58A2.24,2.24,0,0,1,796.34,586.71Z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 787.45,
    y: 559.19,
    width: 11.6,
    height: 31.72,
    rx: 2.46
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 232.86,
    cy: 236.32,
    r: 23.99
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 204.04,
    cy: 290.03,
    rx: 46.93,
    ry: 34.08,
    transform: "translate(-147.65 335.41) rotate(-62.23)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 177.29,
    cy: 381.67,
    rx: 63.4,
    ry: 51.53,
    transform: "matrix(0.14, -0.99, 0.99, 0.14, -224.87, 505.68)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 50.69,
    cy: 314.94,
    r: 22.18
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 65.33,
    cy: 365.84,
    rx: 31.07,
    ry: 40.41,
    transform: "translate(-81.71 24.54) rotate(-13.18)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 86.11,
    cy: 448.97,
    rx: 44.57,
    ry: 54.85,
    transform: "translate(-74.92 21.12) rotate(-9.77)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M124.22,601.86a2,2,0,0,1-2-1.75C110.41,506.42,77.87,425,77.54,424.23a2,2,0,1,1,3.71-1.49c.33.81,33.06,82.65,45,176.87a2,2,0,0,1-1.74,2.24Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M148.38,602.89a2,2,0,0,1-2-2c-.25-94,13-169.37,24.15-216.09C182.63,334.13,195,305.27,195.1,305a2,2,0,0,1,3.67,1.59c-.12.28-12.36,28.9-24.38,79.28-11.09,46.48-24.26,121.53-24,215a2,2,0,0,1-2,2Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 81.86,
    y: 600.89,
    width: 105.58,
    height: 245.74,
    rx: 27.57
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M87,833.5a2,2,0,0,1-1.84-1.21,2,2,0,0,1,1-2.63,128.82,128.82,0,0,1,99.33-1.28,2,2,0,0,1-1.49,3.71,124.86,124.86,0,0,0-96.26,1.24A2,2,0,0,1,87,833.5Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8,641.66H98a2,2,0,0,1,0-4H172.8a2,2,0,1,1,0,4Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61,823.05a2,2,0,0,1-2-2V640.25a2,2,0,0,1,4,0v180.8A2,2,0,0,1,153.61,823.05Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M117.14,823.05a2,2,0,0,1-2-2V640.25a2,2,0,0,1,4,0v180.8A2,2,0,0,1,117.14,823.05Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.6b47b50dfd87bbf63eb451772c5b014c.svg";
export { ForwardRef as ReactComponent };